function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVimeo = function SvgVimeo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#65a2d9"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a7ca5"
    },
    d: "M388.741 143.1c-14.305 27.281-24.457 56.289-35.357 85.626-15.398-17.534-27.851-31.056-27.851-31.056h-42.696l-56.832-56.83 31.923 119.672-91.57-67.722-49.145 27.405L259.958 362.94c-8.945 3.024-18.642 5.491-28.691 8.697L352.711 493.08c90.474-36.945 155.064-124.159 159.07-226.94L388.741 143.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M390.401 144.762c-7.096-7.646-17.368-11.717-30.527-12.104-37.152-1.2-63.426 18.566-78.091 58.733a5.965 5.965 0 0 0 1.226 6.106 5.928 5.928 0 0 0 5.947 1.71c4.22-1.16 8.401-1.746 12.435-1.746 5.413 0 12.621.995 16.208 5.735 2.75 3.641 3.125 9.097 1.11 16.219-1.698 6.011-10.449 22.097-21.28 39.117-13.195 20.739-20.482 30.036-22.585 30.036-6.959 0-32.116-111.547-32.809-113.993-7.213-25.566-10.836-38.398-34.299-38.398-17.884 0-57.768 32.658-90.517 61.109-2.015 1.746-3.71 3.22-5.022 4.346a7.786 7.786 0 0 0-1.088 10.702l6.103 7.859a7.78 7.78 0 0 0 10.68 1.576l.336-.241c10.593-7.537 20.604-14.655 28.16-15.048 8.209-.402 15.334 12.428 23.828 42.951 16.175 59.289 40.755 129.96 65.977 129.96 26.357 0 57.804-22.344 98.451-75.242 36.788-47.875 56.489-85.845 57.751-113.473.951-20.859-3.085-36.311-11.994-45.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d1d1"
    },
    d: "M390.401 144.762c-7.096-7.646-17.368-11.717-30.527-12.104-37.152-1.2-63.426 18.566-78.091 58.733a5.965 5.965 0 0 0 1.226 6.106 5.928 5.928 0 0 0 5.947 1.71c4.22-1.16 8.401-1.746 12.435-1.746 5.413 0 12.621.995 16.208 5.735 2.75 3.641 3.125 9.097 1.11 16.219-1.698 6.011-10.449 22.097-21.28 39.117-13.195 20.739-20.482 30.036-22.585 30.036-3.587 0-12.007-29.625-19.42-58.675v148.599c24.426-4.613 53.212-27.479 89.219-74.342 36.788-47.875 56.489-85.845 57.751-113.473.952-20.86-3.084-36.312-11.993-45.915z"
  }));
};
export default SvgVimeo;